import { h } from 'vue'

import api from '@/api'

const namespaced = true

const state = () => ({
  roles: [],
  modules: [],
  requestors: [],
  requestorDetail: {},
  requestorSuperiors: [],
  requestorSuperiorDetail: {},
  transactionDetail: {},
  picsBox: [],
  historyLogs: [],
  successMessage: ''
})

const getters = {
  roles: state => state.roles,
  modules: state => state.modules,
  requestors: state => state.requestors?.length
    ? state.requestors.map(item =>
      ({ label: item.fullname || item.requestorFullName , value: item.employeeId || item.requestorId })
    )
    : [],
  requestorDetail: state => state.requestorDetail,
  requestorSuperiors: state => state.requestorSuperiors?.length
    ? state.requestorSuperiors.map(item =>
      ({ label: item.fullname || item.requestorFullName , value: item.employeeId || item.requestorId })
    )
    : [],
  requestorSuperiorDetail: state => state.requestorSuperiorDetail,
  emailCC: state => state.requestors.length
    ? state.requestors
      .filter(item => !!(item.email || item.requestorEmail))
      .map(item =>
        ({
          label: item.email || item.requestorEmail ,
          value: item.email || item.requestorEmail,
          render({node}) {
            const child = node.children[0]
            return h(node,
              h(child, [
                h('div', { class: 'flex flex-col py-1' }, [
                  h('span', {}, item.fullname || item.requestorFullName),
                  h('small', { class: 'font-semibold' }, item.email || item.requestorEmail)
                ]),
                child.children[1]
              ])
            )
          }
        })
      )
    : [],
  emailTO: state => state.requestors.length
    ? state.requestors
      .filter(item => !!(item.email || item.requestorEmail))
      .map(item =>
        ({
          label: item.email || item.requestorEmail ,
          value: item.email || item.requestorEmail,
          render({node}) {
            const child = node.children[0]
            return h(node,
              h(child, [
                h('div', { class: 'flex flex-col py-1' }, [
                  h('span', {}, item.fullname || item.requestorFullName),
                  h('small', { class: 'font-semibold' }, item.email || item.requestorEmail)
                ]),
                child.children[1]
              ])
            )
          }
        })
      )
    : [],
  transactionDetail: state => state.transactionDetail,
  picsBox: state => state.picsBox,
  historyLogs: state => state.historyLogs,
  successMessage: state => state.successMessage
}

const mutations = {
  SET_ROLES: (state, payload) => {
    state.roles = payload
  },
  SET_MODULES: (state, payload) => {
    state.modules = payload
  },
  SET_REQUESTORS: (state, payload) => {
    state.requestors = payload
  },
  SET_REQUESTOR_DETAIL: (state, payload) => {
    state.requestorDetail = payload
  },
  SET_REQUESTOR_SUPERIORS: (state, payload) => {
    state.requestorSuperiors = payload
  },
  SET_REQUESTOR_SUPERIOR_DETAIL: (state, payload) => {
    state.requestorSuperiorDetail = payload
  },
  SET_TRANSACTION_DETAIL: (state, payload) => {
    state.transactionDetail = payload
  },
  SET_PICS_BOX: (state, payload) => {
    state.picsBox = payload
  },
  SET_HISTORY_LOGS: (state, payload) => {
    state.historyLogs = payload
  },
  SET_SUCCESS_MESSAGE: (state, payload) => {
    state.successMessage = payload
  }
}

const actions = {
  async fetchRoles({ commit }) {
    try {
      const { data } = await api.getRole()
      commit('SET_ROLES', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchModules({ commit }) {
    try {
      const { data: { data } } = await api.getModules()
      commit('SET_MODULES', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchRequestors({ commit }, { isSuperior, ...payload }) {
    try {
      const { data } = await api.getRequestors(payload)
      commit(isSuperior ? 'SET_REQUESTOR_SUPERIORS' : 'SET_REQUESTORS', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchRequestorDetail({ commit }, { isSuperior, ...payload }) {
    try {
      const { data } = await api.getRequestorDetail(payload)
      commit(isSuperior ? 'SET_REQUESTOR_SUPERIOR_DETAIL' : 'SET_REQUESTOR_DETAIL', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async submitTransactions({ commit }, payload) {
    try {
      const { data } = await api.submitTransactions(payload)
      commit('SET_SUCCESS_MESSAGE', data.message)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async approveTransactions({ commit }, payload) {
    try {
      const { data } = await api.approveTransactions(payload)
      commit('SET_SUCCESS_MESSAGE', data.message)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async sendBackTransactions({ commit }, payload) {
    try {
      const { data } = await api.sendBackTransactions(payload)
      commit('SET_SUCCESS_MESSAGE', data.message)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchTransactionDetail({ commit }, payload) {
    try {
      const { data } = await api.getTransactionDetail(payload)
      commit('SET_TRANSACTION_DETAIL', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchPicsBox({ commit }, payload) {
    try {
      const { data } = await api.getPicsBox(payload)
      commit('SET_PICS_BOX', data)
    } catch (err) {
      throw err.data || err.message
    }
  },
  async fetchHistoryLogs({ commit }, payload) {
    try {
      const { data } = await api.getHistoryLogs(payload)
      commit('SET_HISTORY_LOGS', data)
    } catch (err) {
      throw err.data || err.message
    }
  }
}

export default { namespaced, state, getters, mutations, actions }
